module.exports = __webpack_public_path__ + "img/101.a7323419.png";